// @ts-nocheck


import _range from 'lodash/range';
import moment from 'moment';





export const getDaysByWindowDate = (
windowDate,
cols = 7,
rows = 6) =>
{
  const daysCount = cols * rows;
  const year = windowDate.getFullYear();
  const month = windowDate.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthDays = _range(1, daysInMonth + 1).map((day) => {
    return {
      date: new Date(year, month, day)
    };
  });
  const dayWeek =
  new Date(monthDays[0].date).getDay() !== 0 ?
  new Date(monthDays[0].date).getDay() :
  7;
  const nextDays = daysCount - daysInMonth - (dayWeek - 1);
  const beforeDays = _range(1, dayWeek).
  map((day) => {
    return {
      date: new Date(year, month, -(day - 1))
    };
  }).
  reverse();
  const afterDays = _range(1, nextDays + 1).map((day) => {
    return {
      date: new Date(year, month + 1, day)
    };
  });

  return [...beforeDays, ...monthDays, ...afterDays];
};

export const isToday = (date) => {
  return moment(date).isSame(new Date(), 'day');
};

export const isBefore = (date1, date2) => {
  return moment(date1).
  startOf('day').
  isBefore(moment(date2).startOf('day'));
};

export const isCurrentMonth = (date1, date2) => {
  return new Date(date1).getMonth() === new Date(date2).getMonth();
};